// src/utils/quarterUtils.js
export const getQuarterDateRange = (quarterString) => {
  const [year, quarter] = quarterString.split('_');
  const yearNum = parseInt(year);
  const quarterNum = parseInt(quarter.replace('Q', ''));

  let startMonth, endMonth;

  switch (quarterNum) {
    case 1:
      startMonth = 0; // January
      endMonth = 2; // March
      break;
    case 2:
      startMonth = 3; // April
      endMonth = 5; // June
      break;
    case 3:
      startMonth = 6; // July
      endMonth = 8; // September
      break;
    case 4:
      startMonth = 9; // October
      endMonth = 11; // December
      break;
    default:
      throw new Error('Invalid quarter');
  }

  const startDate = new Date(yearNum, startMonth, 1);
  const endDate = new Date(yearNum, endMonth + 1, 0);

  return {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0]
  };
};

export const getMultipleQuartersDateRange = (quarterStrings) => {
  if (!quarterStrings || quarterStrings.length === 0) {
    return { startDate: null, endDate: null };
  }

  const ranges = quarterStrings.map((q) => getQuarterDateRange(q));

  const startDate = ranges.reduce((earliest, range) => {
    return !earliest || range.startDate < earliest ? range.startDate : earliest;
  }, null);

  const endDate = ranges.reduce((latest, range) => {
    return !latest || range.endDate > latest ? range.endDate : latest;
  }, null);

  return { startDate, endDate };
};
